import styled from '@emotion/styled';
import { Button, Dialog, DialogActions, DialogContent, Link, Typography } from '@material-ui/core';
import { createElement, Dispatch, SetStateAction } from 'react';
import { FormattedMessage } from 'react-intl';

import { MaterialTypeDefinition, SearchAssetResult } from '../../../../entity/SearchAsset';

type Props = {
  materialType: MaterialTypeDefinition;
  isOpenPreview: boolean;
  setIsOpenPreview: Dispatch<SetStateAction<boolean>>;
  previewAsset: SearchAssetResult[number] | null;
};

export const Preview = ({ materialType, isOpenPreview, setIsOpenPreview, previewAsset }: Props) => {
  const handleCancelButtonClick = () => {
    setIsOpenPreview(false);
  };

  return (
    <Dialog maxWidth="lg" open={previewAsset != null && previewAsset.type !== 'audio' && isOpenPreview}>
      <DialogContent>
        {previewAsset == null ? null : materialType.name === 'video' ? (
          <PreviewVideo
            src={previewAsset.lightWeightUrl || previewAsset.originalUrl}
            controls={true}
            muted={true}
            autoPlay={true}
          />
        ) : materialType.name === 'image' ? (
          <Image src={previewAsset.lightWeightUrl || previewAsset.originalUrl} />
        ) : materialType.name === 'audio' ? (
          <Audio src={previewAsset.lightWeightUrl || previewAsset.originalUrl} controls={true} />
        ) : null}
        {previewAsset != null && previewAsset.profileUrl != null && previewAsset.photographerName != null && (
          <Typography align="right">
            Photo by&nbsp;
            <Link href={previewAsset.profileUrl} target="_blank">
              {previewAsset.photographerName}
            </Link>
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button variant="contained" size="small" color="default" onClick={handleCancelButtonClick}>
          <FormattedMessage id="search_file_uploader.selector.cancel" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const PreviewVideo = styled('video')`
  max-width: 100%;
`;

const Audio = styled('audio')`
  outline: none;
`;

const Image = styled('img')`
  width: 100%;
  height: auto;
`;
